import { render, staticRenderFns } from "./NewWebsite.vue?vue&type=template&id=c0f48d3c&"
import script from "./NewWebsite.vue?vue&type=script&lang=js&"
export * from "./NewWebsite.vue?vue&type=script&lang=js&"
import style0 from "./NewWebsite.vue?vue&type=style&index=0&id=c0f48d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports